import { render, staticRenderFns } from "./ConsumerAudio.vue?vue&type=template&id=3c3b5f0e&scoped=true&"
import script from "./ConsumerAudio.vue?vue&type=script&lang=js&"
export * from "./ConsumerAudio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c3b5f0e",
  null
  
)

export default component.exports